<template>
  <div>
    <b-card title="Update Job Order" class="mb-4">
      <b-row>
        <b-col cols="12" style="margin-bottom: 15px;">
          <b-button variant="primary" @click="goBack()">
            <feather-icon size="1x" icon="ArrowLeftIcon" />Back to Admin Panel
          </b-button>
        </b-col>
      </b-row>
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="Order Number">
              <b-form-input v-model="form.orderNumber" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="Drum ID">
              <b-form-input v-model="form.drumID" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="form.item.length > 0">
          <b-col md="12">
            <b-form-group label="Picklists">
            <b-row>
              <b-col v-for="(item, idx) in form.item" :key="idx" cols="auto">
                <b-badge variant="secondary" class="mb-1">{{item.orderNumber}}</b-badge>
              </b-col>
            </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="Status">
              <b-form-input v-model="form.status" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="Type">
              <b-form-input v-model="form.props.type" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="JS">
              <b-form-input v-model="updatedData.JS" type="datetime-local" step="1" :disabled="updatedData.JS == ''"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="JE">
              <b-form-input v-model="updatedData.JE" type="datetime-local" step="1" :disabled="updatedData.JE == ''"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="MDS">
              <b-form-input v-model="updatedData.MDS" type="datetime-local" step="1" :disabled="updatedData.MDS == ''"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="MDE">
              <b-form-input v-model="updatedData.MDE" type="datetime-local" step="1" :disabled="updatedData.MDE == ''"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="MSS">
              <b-form-input v-model="updatedData.MSS" type="datetime-local" step="1" :disabled="updatedData.MSS == ''"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="MSE">
              <b-form-input v-model="updatedData.MSE" type="datetime-local" step="1" :disabled="updatedData.MSE == ''"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-right">
            <b-button type="submit" variant="primary">Update</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <!-- <b-alert v-if="success" variant="success" dismissible>Job order updated successfully!</b-alert> -->
  </div>

</template>

<script>
export default {
  data() {
    return {
      form: {
        orderNumber: '',
        item: [],
        drumID: '',
        status: '',
        type: '',
        props: {
          type: '',
          status: ''
        }
      },
      updatedData: {
        JS: '',
        JE: '',
        MDS: '',
        MDE: '',
        MSS: '',
        MSE: '',
      },
    }
  },
  mounted() {
    this.getJobOrder()
  },
  computed: {
    currentUser() {
      let result = {
        updater: 'system',
        userID: null
      }
      const user = this.$store.getters['auth/getActiveUser']
      if (user.props.firstName && user.props.lastName) {
        result.updater = user.props.firstName + ' ' + user.props.lastName
      }
      if (user.id) {
        result.userID = user.id
      }
      return result
    }
  },
  methods: {
    goBack() {
      window.history.back()
    },
    isValidDateString(dateString) {
      if (!dateString) return false;
      const date = new Date(dateString);
      return !isNaN(date.getTime());
    },
    getJobOrder() {
      const id = this.$route.params.id
      this.$store.dispatch("joborder/getJobOrderId", {id}).then((res) => {
        const props = res.props
        this.form = {
          ...res
        }
        const dateFields = ['JS','JE','MDS','MDE','MSS','MSE']
        dateFields.forEach(field => {
          if (props && props[field]) {
            const d = new Date(props[field])
            const pad = n => n < 10 ? '0' + n : n
            const formatted = d.getFullYear() + '-' + pad(d.getMonth()+1) + '-' + pad(d.getDate()) + 'T' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds()) 
            this.$set(this.updatedData, field, formatted)
          }
        })
      }).catch((err) => {
        console.error(err);
      })
    },
    onSubmit() {
      this.success = true
      const dateFields = ['JS','JE','MDS','MDE','MSS','MSE']
      let payload = {}
      dateFields.forEach(field => {
        if (this.updatedData && this.updatedData[field]) {
          const d = new Date(this.updatedData[field]).toISOString()
          payload[field] = d
        }
      })
      payload.updater = this.currentUser.updater
      payload.userID = this.currentUser.userID
      this.$store.dispatch("admin/updateItem", {payload: payload, id: this.$route.params.id, type: 'job_order'})
      .then((res) => {
        this.$bvToast.toast("Update Joborder Success", {
          title: "Success",
          variant: "success",
          solid: true,
        });
      })
      .catch((err) => {
        console.error(err)
        this.$bvToast.toast("Update Joborder Failed", {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
      })
    }
  }
}
</script>